import type { TFunction } from "i18next";

export type ApiErrorBody = {
  code?: string;
  details?: { eventName?: string; startDate?: string };
};

export type EventErrorType = "error" | "warning" | "info";

const EVENT_ERROR_TYPE: Record<string, EventErrorType> = {
  EVENT_NOT_STARTED: "info",
  EVENT_PAUSED: "warning",
  EVENT_CLOSED: "warning",
  EVENT_COMPLETED: "warning",
  EVENT_CANCELLED: "warning",
};

export const mapEventError = (
  body: ApiErrorBody | undefined,
  t: TFunction,
  language: string,
): { message: string; type: EventErrorType } => {
  const code = body?.code;
  const eventName = body?.details?.eventName ?? "";
  const startDate = body?.details?.startDate
    ? new Date(body.details.startDate).toLocaleString(language, {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

  const keys: Record<string, string> = {
    EVENT_INVALID_CODE: "home.errors.invalidCode",
    EVENT_NOT_STARTED: "home.errors.notStarted",
    EVENT_PAUSED: "home.errors.paused",
    EVENT_CLOSED: "home.errors.closed",
    EVENT_COMPLETED: "home.errors.completed",
    EVENT_CANCELLED: "home.errors.cancelled",
    EVENT_UNAVAILABLE: "home.errors.unavailable",
  };

  if (code && keys[code]) {
    return {
      message: t(keys[code], { eventName, startDate }),
      type: EVENT_ERROR_TYPE[code] ?? "error",
    };
  }

  return { message: t("home.invalidCode"), type: "error" };
};
